<section class="public-section cinema-page">
  <header class="public-page-header">
    <h2 class="public-page-title">Cinema</h2>
    <p class="cinema-subtitle">Filmes que já assisti</p>

    <div class="cinema-search">
      <i class="bi bi-search"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Pesquisar por título, elenco ou direção..."
        [(ngModel)]="termoPesquisa"
        (ngModelChange)="pesquisar()">
    </div>
  </header>

  @if (filmesFiltrados.length === 0) {
    <p class="text-muted text-center mt-4">Nenhum filme encontrado.</p>
  }

  <div class="row masonry-grid" #masonryGrid>
    <div class="grid-sizer"></div>
    @for (filme of filmesFiltrados; track filme.id) {
      <div class="grid-item mb-4">
        <div class="card cinema-card">
          @if (filme.thumbnail) {
            <img [src]="getImagemUrl(filme.thumbnail)" class="card-img-top"
              (error)="handleMissingImage($event)" (load)="onImageLoad()" alt="{{ filme.titulo }}">
          }
          <div class="card-body">
            <span class="badge text-bg-secondary cinema-ano">{{ filme.anoLancamento }}</span>
            <h4 class="card-title">
              <a href="javascript:void(0)" (click)="abrirDetalhe(filme)">{{ filme.titulo }}</a>
            </h4>
            @if (filme.avaliacao) {
              <app-star-rating [value]="filme.avaliacao" class="d-block mb-2"></app-star-rating>
            }
            <p class="card-text">{{ filme.descricaoCurta }}</p>
          </div>
        </div>
      </div>
    }
  </div>
</section>
